import { collection, doc, getDocs, query, setDoc, updateDoc, where } from 'firebase/firestore/lite';

import UserProfileData from '../types/userProfileData';
import { firestore } from '../utils/firebase';

export default class UserProfileApi {
  private static readonly collectionReference = collection(firestore, 'userProfiles');

  public static async addUserProfile(userProfile: Omit<UserProfileData, 'id'>) {
    const docRef = doc(this.collectionReference);
    await setDoc(docRef, { ...userProfile, id: docRef.id } as UserProfileData);
    return docRef.id;
  }

  public static async updateUserProfile(id: string, updatedField: { [x: string]: any }) {
    const docRef = doc(firestore, `userProfiles/${id}`);
    await updateDoc(docRef, updatedField);
  }

  public static async getUserProfileByUuid(uuid: string): Promise<UserProfileData | null> {
    const q = query(this.collectionReference, where('uuid', '==', uuid));
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      return null;
    } else {
      return querySnapshot.docs[0].data() as UserProfileData;
    }
  }

  public static async getUserProfiles(): Promise<UserProfileData[]> {
    const q = query(this.collectionReference);
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(docSnap => docSnap.data() as UserProfileData);
  }
}
